export const dashboard = "dashboard";
export const productlisting = "productlisting";
export const productimportexport = "productimportexport";
export const addnewproduct = "addnewproduct";
export const suppliermanagement = "suppliermanagement";
export const SupplierOnBoardManagement = "SupplierOnBoardManagement";
export const DataMeasureListing = "DataMeasureListing";
export const prs = "PRs";
export const polisting = "POs";
export const shop = "shop";
export const rfqlisting = "rfqlisting";
export const Assessments = "Assessments";
export const supplieronboardingaccount = "supplieronboardingaccount";
export const buyeronboardingaccount = "buyeronboardingaccount";
export const supplieruploadcertificates = "supplieruploadcertificates";
export const CreateRFQ = "CreateRFQ";
export const addproduct = "addproduct";
export const PredealESGReport = "PredealESGReport";
export const ISO = "ISO";
export const EditRFQ = "EditRFQ";
export const companylisting = "companylisting";
export const commoditymanagement = "commoditymanagement";
export const registrationpoc = "registrationpoc";
export const buyerbankdetails = "buyerbankdetails";
export const supplierbankdetails = "supplierbankdetails";
export const Questionneaires = "Questionneaires";
export const categorymanagement = "categorymanagement";
export const portfolioesgreport = "Portfolio ESG Report";
export const globalsettings = "globalsettings";
export const pwcframework = "PWC Framework";
export const importpartner = "importpartner";
export const CpanelAssessments = "CpanelAssessments";
export const BankingESGReport = "BankingESGReport";
export const procurementdashboard = "procurementdashboard";
export const ghgdashboard = "ghgdashboard";
export const ghgdashboardops = "GHGDashboardOPs";
export const ekycreport = "ekycreport";
export const PostdealESGReport = "PostdealESGReport";
export const ghgdashboardv2 = "ghgdashboardv2";
export const orgadminonboardingaccount = "orgadminonboardingaccount";
export const AssessmentsOneTime = "AssessmentsOneTime";
export const AssessmentsMonthly = "AssessmentsMonthly";
export const PredealESGReportNew = "predealesgreportnew";
export const vconboardingaccount = "vconboardingaccount";
export const GHGActivity = "GHGActivity";
export const GHGPOC = "GHGPOC";
export const BulkInvoiceUpload = "BulkInvoiceUpload";
export const healthandsafetyreport = "healthandsafetyreport";
export const PostdealESGReportPowerBI = "PostdealESGReportPowerBI";
export const PredealESGReportPowerBI = "PredealESGReportPowerBI";
export const MONTHLYACTIVITY = "MonthlyActivityData";
export const ghgdashboardhsbc = "GHGDashboard_HSBC";
export const EUDRPreScreeningDashboard = "EUDRPreScreeningDashboard";
export const ESGReportDemo = "ESGReportDemo";
export const PredealESGReportDemo = "PredealESGReportDemo";
export const comsumptiondashboard = "PowerBiDashboardOPs";
export const corporatedashboardops = "corporatedashboardops";
export const GHGGeneralKPIs = "GHGGeneralKPIs";
export const EnterpriseSetup = "EnterpriseSetup";
export const Assessments_reporting = "Assessments_reporting";
// AI Verify Extracted Data
export const AIVerifyExtractedData = "AIVerifyExtractedData"
export const AtherDashboard = "AtherDashboard";
export const HealthnSafetyDashboard = "SocialandGovernanceDashboard";
export const EnvironmentalDashboard = "EnvironmentalDashboard";
export const AssessmentsLock = "AssessmentsLock";
export const SupplierTracker = "SupplierTracker";
export const ManageUomConversionFactors = "ManageUomConversionFactors"; 
export const ManageCarbonEmissionFactors = "ManageCarbonEmissionFactors";
export const questionnairemanagement = "Questionnaire"; 
export const DaimlerKPITracker = "Daimler KPI Tracker";
export const DaimlerEnergyBaseline = "Daimler Energy Baseline";
export const SustainabilityReport = "SustainabilityReport";